module.exports = __webpack_public_path__ + "img/h-page4-39.57f65bd9.png";